<template>
    <div class="modal activateLicense" :class="{ 'is-active': activateLicenseModal }" v-if="activateLicenseModal">
        <div class="modal-background" @click="hideModalWrapper"></div>
        <div class="modal-card">
            <form
                :action="action"
                @submit.prevent="activateLicense($event)"
                @input="clearValidation" novalidate
            >
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ locElements.modal_title }}</p>
                    <button class="delete" aria-label="close" @click="hideModalWrapper"></button>
                </header>
                <section class="modal-card-body pt-0">
                    <p class="mb-1">
                        {{ locElements.for }}
                        <b>&laquo;{{ currentBase.name }}&raquo;</b>
                    </p>
                    <div class="field">
                        <div class="control has-icons-left fg-1">
                            <input
                                class="input"
                                type="text"
                                :placeholder="locElements.license_input_placeholder"
                                v-model="form.key"
                            />
                            <span class="icon is-small is-left">
                                <i class="fas fa-key"></i>
                            </span>
                        </div>
                    </div>
                    <p v-show="errorText" class="help is-danger">
                        {{ errorText }}
                    </p>
                    <p class="help" v-html="locMsgs.key_input_note"></p>
                    <div class="content">
                        <license-key-template :base="currentBase" v-if="showLicenseKeyInfo"></license-key-template>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <input type="submit" class="button is-info"
                            :class="{ 'is-loading': isLoading }"
                            :disabled="activateIsDisable"
                            :value="trans.element.button_activate_text"
                    >
                    </button>
                    <button
                        class="button"
                        @click="hideModalWrapper"
                        :class="{ 'is-loading': isLoading }"
                    >
                        {{ trans.element.close_button_text }}
                    </button>
                </footer>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { axiosForm } from '../mixins/axiosFormMixin.js';
    import { closeModalByEsc } from '../mixins/closeModalByEsc.js';

    export default {
        mixins: [
            axiosForm,
            closeModalByEsc,
        ],
        props: {
            trans: Object,
            actions: Object,
        },
        data() {
            return {
                form: {
                    key: ''
                },
                locElements: licenseLocalization.locElements,
                locMsgs: licenseLocalization.locMsgs,
                activateAction: '',
                showLicenseKeyInfo: true,

                okReport: 'Лицензия активирована',
                failReport: 'Ошибка активации лицензии',

                errorText: false,
                needReload: false,
            }
        },
        computed: {
            licKey() {
                return this.currentBase.license.key_parameters;
            },
            ...mapState('baseList', [
                'activateLicenseModal',
                'currentBase',
            ]),
            activateIsDisable() {
                return this.isLoading || this.form.key.length == 0;
            },
        },
        methods: {
            ...mapActions('baseList',
                {
                    hideModal: 'hideActivateLicenseModal',
                }
            ),
            hideModalWrapper() {
                this.hideModal();
                if (this.needReload) {
                    location.reload();
                }
            },
            activateLicense($event) {
                this.errorText = false;

                if (!this.form.key) {
                    this.form.key = this.currentBase.licensing_info.license.key;
                }
                this.needReload = false;
                let activateActionUrl = actions.licenseActivate.replace('base_hash', this.currentBase.hash_id);
                this.submit($event, activateActionUrl, 'PATCH');
            },
            postResultHandler(result) {
                this.needReload = true;
                this.currentBase.licensing_info = result.data;
                this.showLicenseKeyInfo = true;
            },
            postErrorHandler(error) {
                this.needReload = true;
                this.errorText = error.response.data.message ?? this.errors.unexpected;
                try {
                    if (error.response.data.errors.key[0]) {
                        this.errorText = error.response.data.errors.key[0];
                    }
                } catch (handlerError) {}
                this.showLicenseKeyInfo = false;
            }
        },
    }
</script>
